import React, { useState } from 'react'
import { GetAccess } from '../../../../Components/Utils/roles';
import { Link, useLocation, useParams } from 'react-router-dom';
import ContractLayout from './ContractLayout';
import ViewIcon from '../../../../Components/Icons/ViewIcon';
import UseGetDataSearch from '../../../../Components/Hooks/useFetchDataBySearch';
import { useFormik } from 'formik';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import useFetchMDIndex from '../../../../Components/Hooks/useFetchMDIndex';
import * as yup from 'yup';
import { CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import NuDate from '../../../../Components/Utils/NuDate';




function Invoice() {
   const { contractsViewId,invoiceOutgoingViewId } = useParams();
             
     const location = useLocation();
      const currentPage= location.state?.currentPage
      const searchQuery= location.state?.searchQuery
      const state = location.state;
    
             
   
   
                 const [params, setParams] = useState({
                //    page: page,
                //    per_page: pageCount,
                //    search:searchQuery||"",
               
                division:"",
                status:"",
                modeOfPayment:"",
                fromDate:"",
                toDate:"",
                fromDueDate:"",
                toDueDate:"",
                   approvalStatus:state?.approvalStatus? state.approvalStatus :"",
                   category:state?.category? state.category :"",
                 });
               
                
   
                   const { data,getData,dataLoading } = UseGetDataSearch( `/invoices-outgoing/contract/${contractsViewId}`,params);
                    console.log(data,"contractcli");
    
    return (
      <>
      <ContractLayout 
           BackAccess={GetAccess("client_management_module")}
     
     >
       <div className="overflow-x-auto mt-0.5 rounded-md bg-white h-[calc(100vh-160px)]">
       <table className="min-w-full border-separate border-spacing-y-2 text-xs text-left">
         <thead>
           <tr className="text-black font-semibold">
             <th className="px-4 py-2">Ref.</th>
             {/* <th className="px-4 py-2">Client</th> */}
             <th className="px-4 py-2">Amount</th>
             <th className="px-4 py-2">Payment Due Date</th>
             <th className="px-4 py-2">Mode Of Payment</th>
             <th className="px-4 py-2">Status</th>
             <th className="px-4 py-2">Action</th>
           </tr>
         </thead>
         <tbody>
           {data.map((data) => (
             <tr key={data.id} className=" hover:bg-gray-50 rounded-md shadow-sm">
               <td className="px-4 py-2">
                                                                <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`} >
                                                          
                                                          {data.ref}
                                                                </Link>
                                                          
                                                          </td>
                                                        {/* <td className="px-4 py-2">
                                                        <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`} >
                                                          
                                                          {data.clientName}
                                                          </Link>
                                                          
                                                          </td> */}
               {/* <td className="px-4 py-2">{data.ref}</td>
               <td className="px-4 py-2">{data.client}</td> */}
               <td className="px-4 py-2">{Number(data.amount).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
                })}</td>
 <td className="px-4 py-2">{data.date ? (
                                      <NuDate
                                        value={data?.paymentDueDate}
                                        format="DD-MMM-YYYY"
                                      />
                                    ) : (
                                      "N/A"
                                    )}</td>
               {/* <td className="px-4 py-2">{data.paymentDueDate}</td> */}
               <td className="px-4 py-2">{data.modeOfPayment}</td>
               <td className="px-4 py-2">
                 {data.status}
               </td>
               <td className="px-4 py-2 text-gray-500">
                 <Link to={`/invoice/invoice-outgoing/view/${data?.invoiceOutId}`}
                                      state={{
                                        data: data,
                                        from: `/client-management/contracts/invoice/${contractsViewId}`,
                                      }}>
                                            <ViewIcon color="#048178" />

  </Link>
  </td>
             </tr>
           ))}
         </tbody>
       </table>
     </div>
     </ContractLayout>

   
     </>
    )
}

export default Invoice